import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';

import Typography from 'antd/es/typography';
import message from 'antd/es/message';

import PublicLayout from 'layouts/Public.layout';

import useAuth from 'hooks/useAuth';
import usePageTitle from 'hooks/usePageTitle';

import LoginForm from '../components/LoginForm';
import { useFeatureToggles } from 'components/FeatureToggle';

const LoginWrapper = styled.div`
  max-width: 364px;
`;

const loginLogoStyle = {
  width: '140px',
  height: 'auto',
};

const LoginPage = () => {
  const auth = useAuth();
  const { fetchFeatureToggles } = useFeatureToggles();
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);

  usePageTitle('Login');

  useEffect(() => {
    if (loginError) {
      message.error(loginError.message, 2);
    }
  }, [loginError]);

  const onSubmit = useCallback(({ username, password }) => {
    setLoginError(null);
    setIsLoading(true);
    localStorage.clear();
    
    auth.actions.login({ username, password })
      .then(() => {
        fetchFeatureToggles();
      })
      .catch(err => {
        setLoginError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [auth.actions, fetchFeatureToggles]);

  return (
    <PublicLayout logoStyle={loginLogoStyle}>
      <LoginWrapper>
        <Typography.Title level={2} align="middle" style={{ lineHeight: '38px' }}>Login</Typography.Title>
        <LoginForm onSubmit={onSubmit} isLoading={isLoading} />
      </LoginWrapper>
    </PublicLayout>
  );
};

export default LoginPage;
